











































































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { AddPatientRequest, ApiRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, helpers } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { OrgLocation } from '../../types/entity';
import { MemberProfile } from '../../types/response';
import '../../assets/css/AddPatientModal.scss';
const caseNumberValidation = helpers.regex('alphaNumSpecial', /^[a-zA-Z0-9!@#$%^&*(),.?_":{}|<>-]+$/);
declare var google: any;
declare var Buffer: any;
@Component({
    mixins: [validationMixin],
    props: {
        serviceRequest: Object,
    },
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            birthdate: '',
            isAdmin: false,
            address: {
                fullAddress: '',
                city: '',
                state: '',
                zip: '',
                landmark: '',
            },
            patientlocation: '',
            member: ObjectFactory.getCacheService().getMemberInfo(),
            isLienCustomerEnabled: false,
            caseNumber: '', // Added caseNumber field
        };
    },
    validations() {
        const validations = {
            firstName: {
                required,
                regex: (firstName: any) => /^[a-zA-Z ]+$/.test(firstName),
            },
            lastName: {
                required,
                regex: (lastName: any) => /^[a-zA-Z ]+$/.test(lastName),
            },
            email: {
                email,
                required,
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: any) =>
                    MedTransGoConstants.PHONE_REGX.test(phone),
            },
            address: {
                fullAddress: {
                    required,
                },
                state: {
                    required,
                },
                city: {
                    required,
                },
                zip: {
                    required,
                },
            },
            patientlocation: {
                required,
            },
            caseNumber: {
                caseNumberValidation,
            },
        };
        if (!this.$data.isLienCustomerEnabled && this.$data.member.memberType !== 'ORG_LIEN_CUSTOMER') {
            delete validations.email;
        }
        if (this.$data.isAdmin && !this.$data.isLienCustomerEnabled && validations.email) {
            delete validations.email;
        }
        return validations;
    },
    methods: {
        setPreviewImage(e) {
            const files = e.target.files;
            if (files.length === 0) {
                return;
            }
            this.$data.imageFile = e.target.files[0];
            const reader = new FileReader();
            reader.onload = (event) => {
                if (event.target) {
                    this.$data.imagePreview = event.target.result;
                }
            },
                reader.readAsDataURL(files[0]);
        },
    },
})
export default class AddPatientModal extends Vue {
    private patientGoogleAddress: any;
    private show = true;
    private uploadedPhotoId: string = '';
    private locations: OrgLocation[] | undefined = [];
    private maxDate = new Date();
    private isPatientEmailRequired = false;
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();


    public async mounted() {
        this.getGoogleAddress();
        this.getOrganizationLocations();
        this.maxDate.setFullYear(this.maxDate.getFullYear());
        const organizationResponse = await ObjectFactory.getOrganizationService().
            getOrgDetailsById(this.$store.state.serverUrl);
        if (organizationResponse.success && organizationResponse.data) {
            if (organizationResponse.data.lienCustomerEnabled) {
                this.$data.isLienCustomerEnabled = true;
            }
        }
        if (this.sessionInfo.scopes.includes('admin')) {
            this.$data.isAdmin = true;
        }
        if (this.memberProfile.memberType === 'ORG_LIEN_CUSTOMER'
        || (this.$data.isAdmin && this.$data.isLienCustomerEnabled )) {
            this.isPatientEmailRequired = true;
        }
    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.patientGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('patientAddress'), {
                types: ['geocode'],
            },
            );
            this.patientGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(
                    this.patientGoogleAddress,
                );
            });
        });
    }

    /**
     * @author <Durga.S>
     * @description - add new patient
     * @param req {Request} - calls add patient API
     * @param res {Response} - Express Response - success result
     * @returns patients list
     * @throws InvalidRequestException if patient already exists
     */
    private async addPatient() {
        const iHttpService = ObjectFactory.getHttpService();
        const addPatientRequest: AddPatientRequest = {
            fullName: this.$data.firstName + ' ' + this.$data.lastName,
            email: this.$data.email,
            phone: this.$data.phone,
            address: this.$data.address,
            birthdate: this.$data.birthdate,
            location: this.$data.patientlocation,
            caseNumber: this.$data.caseNumber,
        };
        if (this.$data.imageFile) {
            addPatientRequest.profilePhoto = await this.uploadProfileImage();
        }
        const response = await ObjectFactory.getPatientService().addPatient(this.$store.state.serverUrl,
            addPatientRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_ADD_PATIENT'),
                title: 'Success!',
                timeout: 5000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }


    /**
     * @author <Aniket.P>
     * @description API - Returns organization locations
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - list of locations
     * @returns List of oragnazation lists
     * @throws InvalidRequestException if organization id is invalid
     */
    private async getOrganizationLocations() {
        if (!this.locations || this.locations.length <= 0) {
            const memberProfile = ObjectFactory.getCacheService().getValue(
                MedTransGoConstants.FIELD_MEMBER_PROFILE,
            ) as MemberProfile;
            if (memberProfile.organization) {
                const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
                if (response.success && response.data) {
                    response.data.sort((a, b) => (a.locationName || '').localeCompare(b.locationName || ''));
                    this.locations = response.data;
                } else {
                    CommonUtils.showError(response);
                }
            }
        }
    }

    private async uploadProfileImage(): Promise<string> {
        const iHttpService = ObjectFactory.getHttpService();
        const formData = new FormData();
        formData.append('file', this.$data.imageFile);
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
            data: formData,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post(apiRequest);
        if (response.success && response.data) {
            return response.data.fileName;
        } else {
            CommonUtils.showError(response);
            throw new Error('Faled to upload image');
        }
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
            replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }

    private close() {
        if (this.$route.path.endsWith(MedTransGoConstants.URL_ADD)) {
            this.$router.back();
        } else {
            this.$emit('close');
        }
    }

    private validateDate() {
        if (this.$data.birthdate) {
            const birthdate = new Date(this.$data.birthdate);
            const today = new Date();
            if (birthdate > today) {
                this.$data.birthdate = '';
            }
        }
    }
}
